// src/components/analytics/StatsCards.js - Enhanced statistics cards with period selector

const StatsCards = ({ statistics, period, onPeriodChange, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white dark:bg-shayek-dark-100 rounded-lg shadow p-6 animate-pulse border border-shayek-light-300 dark:border-shayek-dark-200">
            <div className="h-4 bg-gray-200 dark:bg-shayek-dark-200 rounded w-24 mb-2"></div>
            <div className="h-8 bg-gray-200 dark:bg-shayek-dark-200 rounded w-16"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!statistics) {
    return null;
  }

  const stats = [
    {
      label: 'Total Reports',
      value: statistics.total || 0,
      color: 'text-gray-900 dark:text-shayek-dark-900',
      bgColor: 'bg-gray-50 dark:bg-shayek-dark-50'
    },
    {
      label: 'Hate Speech',
      value: statistics.hate_speech ?? 0,
      color: 'text-orange-600 dark:text-orange-400',
      bgColor: 'bg-orange-50 dark:bg-orange-900/20'
    },
    {
      label: 'AI Manipulated',
      value: statistics.ai_manipulated ?? 0,
      color: 'text-red-600 dark:text-red-400',
      bgColor: 'bg-red-50 dark:bg-red-900/20'
    },
    {
      label: 'Verified',
      value: statistics.verified || 0,
      color: 'text-green-600 dark:text-green-400',
      bgColor: 'bg-green-50 dark:bg-green-900/20'
    },
    {
      label: 'Pending',
      value: statistics.pending || 0,
      color: 'text-yellow-600 dark:text-yellow-400',
      bgColor: 'bg-yellow-50 dark:bg-yellow-900/20'
    }
  ];

  return (
    <div className="mb-6">
      {/* Period Selector */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-800 dark:text-shayek-dark-900">Statistics</h2>
        <div className="flex gap-2 bg-gray-100 dark:bg-shayek-dark-200 rounded-lg p-1">
          {['daily', 'weekly', 'monthly', 'all'].map((p) => (
            <button
              key={p}
              onClick={() => onPeriodChange(p)}
              className={`px-4 py-1 text-sm rounded capitalize transition-colors ${
                period === p
                  ? 'bg-white dark:bg-shayek-dark-100 text-gray-900 dark:text-shayek-dark-900 shadow-sm font-medium'
                  : 'text-gray-600 dark:text-shayek-dark-500 hover:text-gray-900 dark:hover:text-shayek-dark-700'
              }`}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {stats.map((stat, index) => (
          <div key={index} className={`${stat.bgColor} rounded-lg shadow p-6 border border-shayek-light-300 dark:border-shayek-dark-200 transition-colors`}>
            <h3 className="text-sm font-medium text-gray-600 dark:text-shayek-dark-600 mb-2">{stat.label}</h3>
            <p className={`text-3xl font-bold ${stat.color}`}>{stat.value.toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsCards;

